module.exports = __webpack_public_path__ + "static/img/newAdd.077c83c0.svg";